import React from 'react';
import { withRouter } from "react-router-dom";
import { Card, Icon, Thumbnail, Typography } from "../ecosystem";

const VideoVisitProviderCard = ({
    className,
    photo,
    name,
    specialty,
    scheduleDays,
    getProviderSlots,
    onClick
}) => {

    const cardClassName = `video-visit-provider-card ${className ? ' ' + className : ''}`;

    return (
        <Card borderStyle={"elevated"} className={cardClassName} onClick={onClick}>
            <div className="row video-visit-provider-card-container">
                <div className="col video-visit-provider-card__img-container">
                    <Thumbnail
                        source={photo}
                        icon="doctor"
                        size={"xs"}
                        altText={
                            name + " photo"
                        }
                    />
                </div>
                <div className="col video-visit-provider-card__info-container">
                    <div className="video-visit-provider-card__profile-info">
                        <Typography
                            type="body-01"
                            color={"$color-primary-a2"}
                            tag="div"
                        >
                            {name ? name : 'BSWH Provider'}
                        </Typography>
                        {specialty &&
                            <Typography
                                type="meta-01"
                                color={"$color-secondary-a2"}
                                tag="div"
                            >
                                {specialty}
                            </Typography>
                        }
                    </div>
                    {scheduleDays && getProviderSlots && 
                        <div className="video-visit-provider-card__availability">
                            <Typography
                                type="meta-01"
                                color={"$color-primary-a2"}
                            >
                                Availability: {" "}
                                {getProviderSlots(
                                    scheduleDays
                                )}
                            </Typography>
                        </div>
                    }
                </div>
                <div className="col video-visit-provider-card__arrow">
                    <Icon name="chevron-right" size="small" />
                </div>
            </div>
        </Card>
    )
}

export default withRouter(VideoVisitProviderCard);